export default "__VITE_ASSET__43e8ac70__"